import { Dialog, DialogContent, DialogTitle } from "@workspace/web-ui/components/dialog"
import { ICD10Form } from "../form/icd10-form"
// import { ICD10Form } from "../form/icd10-form"

interface ICD10ModalProps {
    open: boolean
    onOpenChange: (open: boolean) => void
    onSubmit: (data: { icd10_code?: string }) => void
    isLoading?: boolean
    isGenerateFlow?: boolean
}

export const ICD10Modal = ({ open, onOpenChange, onSubmit, isLoading, isGenerateFlow = false }: ICD10ModalProps) => {
    const handleCancel = () => {
        onOpenChange(false)
    }

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="w-full max-w-[450px] flex flex-col p-0 overflow-hidden">
                <DialogTitle></DialogTitle>
                <div className="shrink-0 px-6 pt-2 pb-3">
                    <h2 className="text-2xl font-medium">{isGenerateFlow ? 'Generate Notes' : 'Update Session'}</h2>
                    <p className="text-sm text-gray-500 mt-1">Add an optional ICD-10 code{isGenerateFlow ? ' before generating notes' : ' for this session'}</p>
                </div>
                <div className="flex-1 min-h-0">
                    <ICD10Form 
                        onSubmit={onSubmit} 
                        onCancel={handleCancel} 
                        isLoading={isLoading} 
                    />
                </div>
            </DialogContent>
        </Dialog>
    )
}

